export const back = () => {
  try {
    window.Android.back();
  } catch (e) {
    console.log('back: ' + e)
  }
}

export const finishOrder = () => {
  try {
    window.Android.finishOrder();
  } catch (e) {
    console.log('finishOrder: ' + e)
  }
}

export const receiveCall = () => {
  try {
    window.Android.receiveCall();
  } catch (e) {
    console.log('receiveCall: ' + e)
  }
}
